import * as Sentry from '@sentry/react';

/**
 * Inicjalizacja Sentry po stronie klienta — importowana jako pierwsza rzecz w `main.tsx`.
 *
 * Bez `VITE_SENTRY_DSN` (dev lokalny, gdzie plik `.env` nie jest ustawiany celowo)
 * `Sentry.init` się nie wywołuje i `Sentry.ErrorBoundary`/`captureException` stają się
 * cichymi no-opami — reszta kodu nie musi nigdzie sprawdzać, czy Sentry jest włączone.
 */
const dsn = import.meta.env.VITE_SENTRY_DSN;

/**
 * Jedyna domena, spod której ta aplikacja legalnie działa — `docs/08-decyzje.md` #22.
 *
 * Realny incydent (2026-09-11): kilka zdarzeń zgłosiło adres strony jako zupełnie obcą
 * domenę, mimo że `release` w każdym z nich dokładnie odpowiadał temu, co w danej chwili
 * faktycznie było wdrożone na `seawar.pi24.pl` — build z tego repo (potwierdzone: zero
 * wzmianek o tamtej domenie w zbudowanym `dist/`, dokładnie jedno, spodziewane wywołanie
 * `serviceWorker.register` z relatywną ścieżką w `registerSW.js`) naprawdę się wykonywał,
 * tylko `location` w przeglądarce odwiedzającego był z jakiegoś powodu zniekształcony
 * (najpewniej rozszerzenie przeglądarki albo proxy sieciowe po stronie odwiedzającego,
 * nie nic po stronie serwera). Dwie niezależne bariery, bo te dwa sygnały bywają rozjechane
 * jak w tym incydencie (`allowUrls` patrzy na URL SKRYPTU ze stack trace'u, `beforeSend`
 * dodatkowo na zgłoszony URL STRONY):
 */
const PRODUCTION_ORIGIN = 'https://seawar.pi24.pl';

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_RELEASE,
    // RODO: minimalizacja z docs/06 §6.5 — bez adresu IP i innych danych "za darmo".
    sendDefaultPii: false,
    // Ufamy błędom wyłącznie ze skryptów faktycznie serwowanych z naszej domeny.
    allowUrls: [/^https:\/\/seawar\.pi24\.pl\//],
    // Dodatkowo odsiewa po zgłoszonym adresie STRONY — łapie przypadki bez stack trace'u
    // (jak w tym incydencie), gdzie `allowUrls` samo nie miałoby czego sprawdzić.
    beforeSend(event) {
      const pageUrl = event.request?.url;
      if (pageUrl && !pageUrl.startsWith(PRODUCTION_ORIGIN)) return null;
      return event;
    },
  });
}
